import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=1cbd3d17&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd3d17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbd3d17')) {
      api.createRecord('1cbd3d17', component.options)
    } else {
      api.reload('1cbd3d17', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=1cbd3d17&scoped=true&", function () {
      api.rerender('1cbd3d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tCSgwwHD1ZS6/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports